import { render, staticRenderFns } from "./registryEntries-add.vue?vue&type=template&id=6073ed28&scoped=true&"
import script from "./registryEntries-add.vue?vue&type=script&lang=js&"
export * from "./registryEntries-add.vue?vue&type=script&lang=js&"
import style0 from "./registryEntries-add.vue?vue&type=style&index=0&id=6073ed28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073ed28",
  null
  
)

export default component.exports